import React from 'react';
import { InputNumber, Space, Select } from 'antd';
import { EASING_TYPES } from 'util/constants';
import styles from '../../../event-timeline.module.css';

const { Option } = Select;

interface MoveParamsProps {
  params: any;
  setParams: (params: any) => void;
}

const RotateMainCameraParams: React.FC<MoveParamsProps> = ({
  params,
  setParams,
}) => {
  return (
    <div className={styles.parameterContainer}>
      <Space direction='vertical' style={{ width: '100%' }}>
        <span className={styles.label}>Rotation X in deg:</span>
        <InputNumber
          value={params.rotation?.x || 0}
          onChange={(value) =>
            setParams({
              ...params,
              rotation: {
                ...params.rotation,
                x: value,
              },
            })
          }
          style={{ width: '100%' }}
        />
        <span className={styles.label}>Rotation Y in deg:</span>
        <InputNumber
          value={params.rotation?.y || 0}
          onChange={(value) =>
            setParams({
              ...params,
              rotation: {
                ...params.rotation,
                y: value,
              },
            })
          }
          style={{ width: '100%' }}
        />
        <span className={styles.label}>Rotation Z in deg:</span>
        <InputNumber
          value={params.rotation?.z || 0}
          onChange={(value) =>
            setParams({
              ...params,
              rotation: {
                ...params.rotation,
                z: value,
              },
            })
          }
          style={{ width: '100%' }}
        />
        <span className={styles.label}>Easing:</span>
        <Select
          value={params.easing || 'linear'}
          onChange={(value) => setParams({ ...params, easing: value })}
          style={{ width: '100%' }}
        >
          <Option value={EASING_TYPES.LINEAR}>Linear</Option>
          <Option value={EASING_TYPES.EASE_IN}>Ease In</Option>
          <Option value={EASING_TYPES.EASE_OUT}>Ease Out</Option>
          <Option value={EASING_TYPES.EASE_IN_OUT}>Ease In Out</Option>
        </Select>
      </Space>
    </div>
  );
};

export default RotateMainCameraParams;
